"use client";

import { c as _c } from "react/compiler-runtime";
import { SellerUnitsAndProjectsOne } from "@/types/sup";
import currencify from "@/utils/currencify";
import { formatPricePerSqft } from "@/utils/currency/get-rate";
import { formatRange } from "@/utils/format-range";
import { SectionContent, SectionTitle } from "../seller-unit/section-components";
import { SpaceItem } from "../seller-unit/space-item";
interface OverviewSectionProps {
  supOne: SellerUnitsAndProjectsOne;
  isLoading?: boolean;
  className?: string;
}
interface OverviewItem {
  icon: string;
  label: string;
  value: string;
  available: boolean | undefined;
  tooltip?: React.ReactNode;
}
export function OverviewSection(t0) {
  const $ = _c(37);
  const {
    supOne,
    className
  } = t0;
  const hasNonZeroValues = _temp2;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== className || $[1] !== supOne.balconies || $[2] !== supOne.bathrooms || $[3] !== supOne.bedrooms || $[4] !== supOne.builtUpAreas || $[5] !== supOne.currentRate || $[6] !== supOne.halls || $[7] !== supOne.kitchens || $[8] !== supOne.parkings || $[9] !== supOne.prices?.[0] || $[10] !== supOne.type) {
    const items = [{
      icon: "bedroom",
      label: "Bedrooms",
      value: formatRange({
        data: supOne.bedrooms,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.bedrooms)
    }, {
      icon: "bathroom",
      label: "Bathrooms",
      value: formatRange({
        data: supOne.bathrooms,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.bathrooms)
    }, {
      icon: "kitchen",
      label: "Kitchen",
      value: formatRange({
        data: supOne.kitchens,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.kitchens)
    }, {
      icon: "hall",
      label: "Hall",
      value: formatRange({
        data: supOne.halls,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.halls)
    }, {
      icon: "parking",
      label: "Parking",
      value: formatRange({
        data: supOne.parkings,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.parkings)
    }, {
      icon: "balcony",
      label: "Balcony",
      value: formatRange({
        data: supOne.balconies,
        withSpaces: false
      }),
      available: hasNonZeroValues(supOne.balconies)
    }, {
      icon: "builtup-area",
      label: "Builtup Area",
      value: formatRange({
        data: supOne.builtUpAreas,
        withSpaces: false
      }) + " sft",
      available: !!supOne.builtUpAreas?.length
    }];
    const priceNum = supOne.prices?.[0];
    let t5;
    if ($[16] !== priceNum) {
      t5 = priceNum ? currencify({
        amount: priceNum,
        abbreviated: true
      }) : "";
      $[16] = priceNum;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    const priceStr = t5;
    let t6;
    if ($[18] !== priceNum || $[19] !== supOne.builtUpAreas?.[0] || $[20] !== supOne.currentRate) {
      t6 = supOne.currentRate ? Math.round(supOne.currentRate).toLocaleString() : formatPricePerSqft({
        price: priceNum || 0,
        area: supOne.builtUpAreas?.[0] || 0
      });
      $[18] = priceNum;
      $[19] = supOne.builtUpAreas?.[0];
      $[20] = supOne.currentRate;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    const rate = t6;
    T0 = SectionContent;
    t3 = `${className} flex flex-col`;
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div>Overview</div>;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    let t8;
    if ($[23] !== priceStr || $[24] !== rate || $[25] !== supOne.type) {
      t8 = priceStr && <div className="text-right font-bold"><div className="text-lg text-primary">{`₹${priceStr}` + (supOne.type === "sp" ? "+" : "")}</div>{rate && <div className="text-xs">{rate} /sft</div>}</div>;
      $[23] = priceStr;
      $[24] = rate;
      $[25] = supOne.type;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    if ($[27] !== t8) {
      t4 = <SectionTitle><div className="flex items-center justify-between">{t7}{t8}</div></SectionTitle>;
      $[27] = t8;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    t1 = "flex justify-evenly items-center pt-8 pb-4 flex-wrap gap-4 gap-y-8 flex-1";
    t2 = items.filter(_temp3).map(_temp4);
    $[0] = className;
    $[1] = supOne.balconies;
    $[2] = supOne.bathrooms;
    $[3] = supOne.bedrooms;
    $[4] = supOne.builtUpAreas;
    $[5] = supOne.currentRate;
    $[6] = supOne.halls;
    $[7] = supOne.kitchens;
    $[8] = supOne.parkings;
    $[9] = supOne.prices?.[0];
    $[10] = supOne.type;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    T0 = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
  }
  let t5;
  if ($[29] !== t1 || $[30] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== T0 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5) {
    t6 = <T0 className={t3}>{t4}{t5}</T0>;
    $[32] = T0;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  return t6;
}
function _temp4(item_0, index) {
  return <SpaceItem key={index} label={item_0.label} available={item_0.available ?? false} icon={item_0.icon} value={item_0.value?.toString() || ""} tooltip={item_0.tooltip} />;
}
function _temp3(item) {
  return item.available;
}
function _temp2(data) {
  return data && data.length > 0 && data.some(_temp);
}
function _temp(val) {
  return val > 0;
}